import { Link } from "react-router-dom";
import ImageWithBasePath from "../imageWithBasePath";
import { useAppSelector } from "store/store";
import { useDispatch } from "react-redux";
import { setThemeSettings } from "store/uiSlice";
import { logout } from "store/userSlice";

export default function ProfileDropdown() {
  const dispatch = useDispatch();
  const user = useAppSelector((state) => state.user.data);

  function handleLogout() {
    sessionStorage.clear();
    localStorage.clear();
    dispatch(logout());
  }

  return (
    <li className="nav-item dropdown has-arrow main-drop">
      <Link to="#" className="nav-link userset" data-bs-toggle="dropdown">
        <span className="user-info">
          <span className="user-letter">
            <div className="avatar avatar-sm rounded-circle border">
              <i className="ti ti-user-filled text-black fs-5" />
            </div>
          </span>
          <span className="badge badge-success rounded-pill" />
        </span>
      </Link>
      <div className="dropdown-menu menu-drop-user">
        <div className="profilename">
          {/* <Link className="dropdown-item" to={route.dealsDashboard}>
            <i className="ti ti-layout-2" /> Dashboard
          </Link> */}
          {/* <Link className="dropdown-item" to={"/profile"}>
            <i className="ti ti-user-pin" /> Profilim
          </Link> */}
          <Link
            className="dropdown-item color-warning"
            to="#"
            state={{ color: "red" }}
            onClick={handleLogout}
          >
            <i className="ti ti-lock" /> Çıkış Yap
          </Link>
        </div>
      </div>
    </li>
  );
}
